import { render, staticRenderFns } from "./BookingSiteSettingsList.vue?vue&type=template&id=bcd4e7ba&scoped=true"
import script from "./BookingSiteSettingsList.vue?vue&type=script&lang=js"
export * from "./BookingSiteSettingsList.vue?vue&type=script&lang=js"
import style0 from "./BookingSiteSettingsList.vue?vue&type=style&index=0&id=bcd4e7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd4e7ba",
  null
  
)

export default component.exports